import { Card as AntdCard } from "antd";
import "./styles.css";
import { useRef } from "react";

export const Card = ({ children, ...others }) => {
  const cardRef = useRef(null);
  return (
    <AntdCard ref={cardRef} className="card" {...others}>
      {children}
    </AntdCard>
  );
};
